import React from 'react'
import './SentReceiveMessage.css';
import UserIcon from '../../../assets/images/user-icon3.png';
import MessageComponent from '../../../components/MessageComponent';

const SentMessage = ({message}) => {
  return (
    <div className='sent-message'>
      <div className='sent-message-container'>
        {/* <div className='sent-message-text '>{message}</div> */}
        <MessageComponent message={message} msgType="sent"/>
        <div className='sent-message-image'>
          <div className='sent-message-image2'>
            <img src={UserIcon} alt='icon' />
          </div>
        </div>
      </div>
      <p className='sent-message-time mt-1'>10:56 AM</p>
    </div>
  )
}

export default SentMessage
